// AUTO-GENERATED by build-sfx-sprite.js — do not edit manually
// Run "npm run build:sfx" to regenerate
export const SFX_SPRITE_MAP = {
  "basic_win": [
    0,
    1000
  ],
  "bonus_end": [
    2000,
    1557.823129251701
  ],
  "bonus_intro_popup": [
    5000,
    3938.321995464852
  ],
  "big_win_in": [
    10000,
    5777.777777777778
  ],
  "big_win_idle": [
    17000,
    2374.9886621315213
  ],
  "big_win_out": [
    21000,
    3659.0929705215417
  ],
  "button_click": [
    26000,
    120.000000000001
  ],
  "c_in": [
    28000,
    187.0975056689339
  ],
  "c_win": [
    30000,
    874.6485260770988
  ],
  "cc_in": [
    32000,
    750
  ],
  "cc_update": [
    34000,
    799.9999999999972
  ],
  "cd_in": [
    36000,
    750
  ],
  "cd_multiply": [
    38000,
    874.9886621315213
  ],
  "cm_in": [
    40000,
    750
  ],
  "cm_stop_major": [
    42000,
    1000
  ],
  "cm_stop_mini": [
    44000,
    945.7369614512459
  ],
  "cm_stop_minor": [
    46000,
    1082.9251700680302
  ],
  "cm_transform": [
    49000,
    874.9886621315213
  ],
  "collector_in": [
    51000,
    845.7823129251665
  ],
  "counter_end": [
    53000,
    1000
  ],
  "feature_anticipation_in": [
    55000,
    3166.6666666666642
  ],
  "feature_anticipation_out": [
    60000,
    3166.6666666666642
  ],
  "gjp_reel_glow": [
    65000,
    3000
  ],
  "gjp_win": [
    69000,
    3000
  ],
  "intro_popup": [
    73000,
    8000
  ],
  "jackpot_collect": [
    82000,
    2000
  ],
  "j_rotate": [
    85000,
    1500
  ],
  "j_win": [
    88000,
    1019.8412698412653
  ],
  "lightning_end": [
    91000,
    413.6507936507883
  ],
  "lightning_fly": [
    93000,
    628.0045351473973
  ],
  "max_win_in": [
    95000,
    5777.755102040814
  ],
  "max_win_idle": [
    102000,
    2750
  ],
  "max_win_out": [
    106000,
    5777.777777777772
  ],
  "mega_win_in": [
    113000,
    5777.777777777772
  ],
  "mega_win_idle": [
    120000,
    2750
  ],
  "mega_win_out": [
    124000,
    5777.777777777772
  ],
  "particles_end": [
    131000,
    413.6507936507883
  ],
  "particles_fly": [
    133000,
    660.3628117913729
  ],
  "pot_blitz_anticipation": [
    135000,
    1124.9886621315284
  ],
  "pot_collect": [
    138000,
    1500
  ],
  "pot_in": [
    141000,
    1000
  ],
  "pot_trigger": [
    143000,
    1687.4829931972783
  ],
  "pot_win": [
    146000,
    2000
  ],
  "pot_anticipation": [
    149000,
    1126.5759637188069
  ],
  "quick_stop": [
    152000,
    511.56462585032614
  ],
  "reel_stop": [
    154000,
    148.32199546484048
  ],
  "generic_popup_idle": [
    156000,
    2750
  ],
  "respins_left_in": [
    160000,
    5874.988662131528
  ],
  "respins_counter": [
    167000,
    1000
  ],
  "spin": [
    169000,
    106.41723356008015
  ],
  "super_mega_win_in": [
    171000,
    5777.777777777772
  ],
  "super_mega_win_idle": [
    178000,
    2750
  ],
  "super_mega_win_out": [
    182000,
    5777.777777777772
  ],
  "transition": [
    189000,
    3250
  ],
  "total_win_in": [
    194000,
    5777.777777777772
  ],
  "total_win_idle": [
    201000,
    2000
  ],
  "total_win_out": [
    204000,
    5777.777777777772
  ]
};
